import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { FiliaisComponent } from './filiais/filiais.component';
import { FiliaisEditComponent } from './components/filiais-edit/filiais-edit.component';
import { FiliaisRoutingModule } from './filiais-routing.module';
import { FiliaisListComponent } from './components/filiais-list/filiais-list.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    FiliaisRoutingModule,
    MatIconModule
  ],
  declarations: [
    FiliaisComponent,
    FiliaisEditComponent,
    FiliaisListComponent]
})
export class FiliaisModule { }
